import {
    GivelifyColorPalette,
    GivelifyIcon,
    GivelifyLabel,
} from '@givelify/givelify-ui';
import { styled, Menu } from '@mui/material';

const title = 'title';
const action = 'action';
const shortName = 'shortName';
const address = 'address';

export const Wrapper = styled('div', {
    shouldForwardProp: (prop) => prop !== 'isInactive',
})<{ isInactive?: boolean }>(({ theme, isInactive }) => ({
    padding: '13px 13px 16px 16px',
    borderRadius: 10,
    boxShadow: '0px 0px 6px rgba(118, 142, 168, 0.4)',
    display: 'grid',
    alignItems: 'center',
    gridTemplateColumns: 'auto 1fr auto',
    gridTemplateAreas: `
        "shortName shortName edit"
        "title title title"
        "address address address"
        "action . ."
    `,
    [theme.breakpoints.up('md')]: {
        gap: 4,
        padding: 16,
        paddingRight: 32,
        gridTemplateColumns: '1fr 170px 120px',
        gridTemplateAreas: `
            "shortName action edit"
            "title action edit"
            "address action edit"
        `,
    },
    ...(isInactive && {
        '& > *:not(.actionWrapper):not(.edit)': {
            opacity: 0.5,
        },
    }),
}));

export const Title = styled(GivelifyLabel)(({ theme }) => ({
    gridArea: title,
    [theme.breakpoints.down('sm')]: {
        marginTop: 10,
        marginBottom: 8,
    },
}));

export const ActionWrapper = styled('div')({
    gridArea: action,
    display: 'flex',
    alignItems: 'center',
    justifySelf: 'center',
    color: `${GivelifyColorPalette.neutralGrey} !important`,
    fontSize: 16,
    '& svg': {
        marginRight: 8,
    },
    minWidth: 200,
});

export const ShortName = styled(GivelifyLabel)(({ theme }) => ({
    gridArea: shortName,
    maxWidth: 550,
    [theme.breakpoints.up('md')]: {
        marginBottom: 4,
    },
}));

export const Address = styled('div')(({ theme }) => ({
    gridArea: address,
    maxWidth: 550,
    [theme.breakpoints.up('md')]: {
        display: 'flex',
        flexDirection: 'row',
    },
    [theme.breakpoints.down('sm')]: {
        marginBottom: 20,
    },
}));

export const StyledMenu = styled(Menu)({
    '& .MuiPaper-root': {
        boxShadow: '0px 0px 8px rgba(152, 162, 173, 0.73)',
        width: 248,
    },
});

export const MenuItem = styled('div')({
    paddingTop: 11,
    paddingBottom: 11,
    paddingLeft: 16,
});

export const PendingIcon = styled(GivelifyIcon)({
    color: '#DC9F00',
});
